document.addEventListener("DOMContentLoaded", function () {

  const allTabSections = document.querySelectorAll('.cus-product-tabs');

  allTabSections.forEach(section => {

    const tabButtons = section.querySelectorAll('.tab-btn');
    const tabPanes = section.querySelectorAll('.tab-pane');

    tabButtons.forEach(button => {

      button.addEventListener('click', function () {

        const tabId = this.getAttribute('data-tab');

        // remove active classes
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));

        // activate current button
        this.classList.add('active');

        // activate current pane INSIDE SAME SECTION
        const activePane = section.querySelector('#' + tabId);

        if(activePane){
          activePane.classList.add('active');
        }

      });

    });

  });

});